
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SearchableDocumentsList from "@/components/documents/SearchableDocumentsList.vue";
  import UploadDocument from "@/components/documents/UploadDocument.vue";
  import { User } from "@/generated/graphql";

  @Component({
    components: {
      SearchableDocumentsList,
      UploadDocument,
    },
  })
  export default class GroupDocuments extends Vue {
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly groupId!: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    get query(): Object {
      return {
        team_id: { _eq: this.$route.params.id },
      };
    }
  }
